<div [classList]="containerClassToAplly() + (hasGlobalMessages() ? '-global-message' : '')">

  <app-notification></app-notification>

  <!-- Rendered immediately (no @defer) and the host reserves 40px via SCSS so
       that when the messages API resolves the banner already has space — no CLS. -->
  <app-global-message class="sticky-top"></app-global-message>

  @if (showAppHeader()) {
  <app-header class="sticky-top header"></app-header>
  }

  @if (showAppCartPreview()) {
  <app-cart-preview class="cart-preview" [class.cart-preview-height]="!hasGlobalMessages()"
    [class.cart-preview-height-global-message]="hasGlobalMessages()" [class.offcanvas-opened]="isSidebarOpen()">
  </app-cart-preview>
  }

  <main id="main-content" class="main-container" appScrollToTop
    [class.header-showing]="showAppHeader() && !hasGlobalMessages()"
    [class.header-showing-global-message]="showAppHeader() && hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav]="!shouldShowCategoriesBar() && !hasGlobalMessages()"
    [class.header-showing-hidden-sub-nav-global-message]="!shouldShowCategoriesBar() && hasGlobalMessages()"
    [class.cart-preview-showing]="showAppCartPreview()" [class.mobile-main-container]="showMobileFooter()"
    [class.hidden-mobile-footer]="!showMobileFooter()">
    <router-outlet />
  </main>

  @if (showJustAddedProduct()) {
  <app-product-added-notification class="cart-preview just-added-product-notification">
  </app-product-added-notification>
  }

  @if (showMobileFooter()) {
  <app-mobile-footer-menu></app-mobile-footer-menu>
  }

  @if (loadingService.isShowGlobalLoading()) {
  <app-loading></app-loading>
  }

</div>